import { StaffLeaveQuota, StaffLeaveRequest } from '../types';

export const INITIAL_LEAVE_QUOTAS: StaffLeaveQuota[] = [
  {
    staff_id: 'staff-01',
    staff_name: 'รปภ. สมศักดิ์ มั่งมี',
    department: 'ฝ่ายรักษาความปลอดภัย (Security Team)',
    sick_total: 30,
    sick_used: 3,
    personal_total: 6,
    personal_used: 2,
    vacation_total: 10,
    vacation_used: 4,
  },
  {
    staff_id: 'staff-02',
    staff_name: 'ช่างวิชัย แสงทอง',
    department: 'ฝ่ายอาคารและงานช่าง (Engineering & Maintenance)',
    sick_total: 30,
    sick_used: 1,
    personal_total: 6,
    personal_used: 1,
    vacation_total: 10,
    vacation_used: 2,
  },
  {
    staff_id: 'staff-03',
    staff_name: 'น.ส. พรทิพย์ สุวรรณโชติ',
    department: 'ฝ่ายภูมิทัศน์และทำความสะอาด (Housekeeping)',
    sick_total: 30,
    sick_used: 2,
    personal_total: 6,
    personal_used: 0,
    vacation_total: 10,
    vacation_used: 5,
  },
  {
    staff_id: 'admin-01',
    staff_name: 'คุณศศิธร เจริญสุข',
    department: 'ฝ่ายบริหารจัดการนิติบุคคล (Juristic Office)',
    sick_total: 30,
    sick_used: 0,
    personal_total: 6,
    personal_used: 1,
    vacation_total: 12,
    vacation_used: 3,
  },
];

export const INITIAL_LEAVE_REQUESTS: StaffLeaveRequest[] = [
  {
    id: 'leave-1',
    staff_id: 'staff-01',
    staff_name: 'รปภ. สมศักดิ์ มั่งมี',
    department: 'ฝ่ายรักษาความปลอดภัย',
    role_title: 'หัวหน้าชุด รปภ. ผลัดกลางวัน',
    leave_type: 'vacation',
    start_date: '2026-08-20',
    end_date: '2026-08-22',
    total_days: 3,
    reason: 'พาลูกเข้ามอบตัวโรงเรียนประจำจังหวัดและทำธุระครอบครัวต่างจังหวัด',
    status: 'approved',
    reviewed_by: 'คุณศศิธร (ผู้จัดการนิติ)',
    reviewer_note: 'อนุมัติเรียบร้อย จัด รปภ. สมเกียรติ สลับเข้าเวรแทนแล้ว',
    reviewed_at: new Date(Date.now() - 3600000 * 24 * 2).toISOString(),
    created_at: new Date(Date.now() - 3600000 * 24 * 3).toISOString(),
  },
  {
    id: 'leave-2',
    staff_id: 'staff-02',
    staff_name: 'ช่างวิชัย แสงทอง',
    department: 'ฝ่ายอาคารและงานช่าง',
    role_title: 'ช่างไฟฟ้าและประปาอาคาร',
    leave_type: 'sick',
    start_date: '2026-08-16',
    end_date: '2026-08-16',
    total_days: 1,
    reason: 'มีอาการไข้หวัด ปวดศีรษะ พบแพทย์และพักรักษาตัวตามแพทย์สั่ง',
    attachment_url: 'https://images.unsplash.com/photo-1584515979956-d9f6e5d09982?w=500&auto=format&fit=crop&q=80',
    status: 'pending',
    created_at: new Date(Date.now() - 3600000 * 5).toISOString(),
  },
  {
    id: 'leave-3',
    staff_id: 'staff-03',
    staff_name: 'น.ส. พรทิพย์ สุวรรณโชติ',
    department: 'ฝ่ายภูมิทัศน์และทำความสะอาด',
    role_title: 'พนักงานดูแลสวนและคลับเฮาส์',
    leave_type: 'personal',
    start_date: '2026-08-25',
    end_date: '2026-08-25',
    total_days: 1,
    reason: 'ต่อใบขับขี่และดำเนินการเอกสารที่กรมการขนส่งทางบก',
    status: 'pending',
    created_at: new Date(Date.now() - 3600000 * 12).toISOString(),
  },
  {
    id: 'leave-4',
    staff_id: 'staff-01',
    staff_name: 'รปภ. สมศักดิ์ มั่งมี',
    department: 'ฝ่ายรักษาความปลอดภัย',
    role_title: 'หัวหน้าชุด รปภ. ผลัดกลางวัน',
    leave_type: 'emergency',
    start_date: '2026-07-10',
    end_date: '2026-07-10',
    total_days: 1,
    reason: 'เหตุฉุกเฉินน้ำท่วมขังทางเข้าบ้านพักในชุมชน',
    status: 'approved',
    reviewed_by: 'คุณศศิธร (ผู้จัดการนิติ)',
    reviewer_note: 'อนุมัติเป็นกรณีพิเศษ',
    reviewed_at: '2026-07-10T09:00:00.000Z',
    created_at: '2026-07-10T06:30:00.000Z',
  },
];
